export default __webpack_public_path__ + "static/media/contactIcon3.6d3d6cae.png";